(function () {
    'use strict';

    angular.module("imApp").factory("workService", ['$ihttp', function ($ihttp) {
        var call = function (method, parameters) {
            return $ihttp.post({
                method: method,
                parameters: parameters || {}
            });
        };

        var utoa = function (data) { // Utility function for base64encode with unicode support
            return btoa(unescape(encodeURIComponent(data)));
        }

        var atou = function (data) { // Utility function for base64decode with unicode support
            return decodeURIComponent(escape(atob(data)));
        }

        let definedAndNotNull = function (parm) {
            return defined(parm) && parm !== null;
        }

        let defined = function (parm) {
            return angular.isDefined(parm);
        }

        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1341,
                    parameters: parms || {}
                });
            },
            listLinkTypes: function (parms) {
                return $ihttp.post({
                    method: 2063,
                    parameters: parms || {}
                });
            },
            listOperations: function (parms) {
                return $ihttp.post({
                    method: 3902,
                    parameters: parms || {}
                });
            },
            changeOperation: function (parms) {
                return $ihttp.post({
                    method: 2650,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1342,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1354,
                    parameters: edit
                });
            },
            remember: function (rememberId, value, method, isBase) {
                return call(definedAndNotNull(method) ? method : 616, { // for use if need to have a different method
                    is_base64: defined(isBase) ? isBase : 1, //defaults to true
                    variablename: rememberId,
                    variablevalue: defined(isBase) && isBase === false ? angular.toJson(value) : utoa(angular.toJson(value)) //defaults to true
                });
            },
            getRemember: function (rememberId, method) {
                return call(definedAndNotNull(method) ? method : 973, { variablename: rememberId }); // for use if need to have a different method
            }
        };

        return service;
    }]);
})();
